export default __webpack_public_path__ + "static/media/central_andes_1_11.cb1aa1a2.JPG";